import React from 'react'

function footer() {
  return (
    <div className='footer'>
      <img src="page1.png" style={{height:"80px",marginTop:"20px"}} alt="" />
      {/* <img src="Screenshot 2024-10-17 at 23-08-16 spacegut report - vvUzA8QFT6z7ur-cm5ackR9uchBrQxCvanZZ6daPO-xFN7ZjQ1udtbpKwK_PZLWanLg4lXqnqB452FFptt6hdKxAfzvIwGr20nKU4QgoCQtK.pdf.png" alt="" /> */}
    </div>
  )
}

export default footer
